import { RegionGeneratedEntity } from "./generated/RegionGeneratedEntity";

export abstract class RegionEntity extends RegionGeneratedEntity {
    // Comment to preserve new line
}
